import Input from "../../../common/Input";

// contact: {
//   contactNo: "9876543210",
//   email: "store@example.com",
//   email2: "support@example.com",
// },

const Contact = ({
	handleChange,
	values,
	setFieldTouched,
	errors,
	touched,
	isEdit,
	handleEditIconClick,
	handleBlur,
	editingField,
	isDisabled,
}) => {
	// const { handleChange, values, setFieldTouched, errors, touched } = formik;
	return (
		<div className="mb-3">
			<h2 className="text-black-lose text-[13px] font-medium mb-2">Contact</h2>
			<div className="grid grid-cols-12 gap-[8px]">
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Contact No.*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="contact.contactNo"
						id="contact.contactNo"
						value={values.contact.contactNo}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("contact.contactNo", true, false); // Mark the field as touched
						}}
						isError={
							touched?.contact?.contactNo && Boolean(errors?.contact?.contactNo)
						}
						errorMessage={errors?.contact?.contactNo}
						disabled={isDisabled && editingField !== "contact.contactNo"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("contact.contactNo") : "")}
						onEditClick={() => handleEditIconClick("contact.contactNo")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Email*"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="contact.email"
						id="contact.email"
						value={values.contact.email}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("contact.email", true, false); // Mark the field as touched
						}}
						isError={touched?.contact?.email && Boolean(errors?.contact?.email)}
						errorMessage={errors?.contact?.email}
						disabled={isDisabled && editingField !== "contact.email"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("contact.email") : "")}
						onEditClick={() => handleEditIconClick("contact.email")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
				<div className="col-span-4">
					<Input
						placeholder="Enter"
						inputBox="mb-0"
						type="text"
						labelName="Email 2"
						labelClassName="block text-primary-400 text-[13px] leading-[20px]"
						className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
						name="contact.email2"
						id="contact.email2"
						value={values.contact.email2}
						onChange={(e) => {
							handleChange(e);
							setFieldTouched("contact.email2", true, false); // Mark the field as touched
						}}
						isError={
							touched?.contact?.email2 && Boolean(errors?.contact?.email2)
						}
						errorMessage={errors?.contact?.email2}
						disabled={isDisabled && editingField !== "contact.email2"}
						showEditIcon={isEdit}
						onBlur={() => (handleBlur ? handleBlur("contact.email2") : "")}
						onEditClick={() => handleEditIconClick("contact.email2")}
						disabledClass="bg-primary-50 border-primary-50 "
					/>
				</div>
			</div>
		</div>
	);
};

export default Contact;
